import type { DeckPassivePresentation } from '@cards/cards';
import type { ReactElement } from 'react';
import { AuthoredGlyph } from './AuthoredGlyph.js';
import { Badge } from './kit/index.js';

export interface DeckPassiveDetailsProps {
  presentation: DeckPassivePresentation;
  density?: 'compact' | 'comfortable';
  testId: string;
}

/** Card-independent presentation shared by editor, match HUD and replay surfaces. */
export function DeckPassiveDetails({
  presentation,
  density = 'comfortable',
  testId,
}: DeckPassiveDetailsProps): ReactElement {
  return (
    <div
      className={`cards-deck-passive-details cards-deck-passive-details-${density}`}
      data-testid={testId}
      data-passive-id={presentation.id}
    >
      <AuthoredGlyph
        glyph={presentation.glyph}
        testId={`${testId}-glyph`}
        visualId={presentation.id}
        size={density === 'compact' ? 18 : 40}
        className="cards-deck-passive-glyph"
      />
      <div className="cards-deck-passive-copy">
        <div className="cards-deck-passive-heading">
          <strong>{presentation.name}</strong>
          {density === 'comfortable' ? <Badge tone="info">Пассивка колоды</Badge> : null}
        </div>
        <span className="cards-deck-passive-description">{presentation.description}</span>
      </div>
    </div>
  );
}
